import { Box, TableCell, TableRow, Typography } from '@mui/material';
import strings from '../../../common/Translation/Translate';
import Tabular from '../../../components/Tabular/Tabular';

const LoyaltyProgramSection = ({ loyaltyProgram }: any) => {
  return (
    <Box mt={2}>
      <Typography sx={{ borderBottom: `1px` }} color="primary" mb={2} pb={1} fontWeight="bold">
        {strings.LoyaltyProgram}
      </Typography>
      <Tabular
        rows={[strings.name, strings.referenceNo, strings.remark]}
        sx={{ 'thead > tr, tbody > tr': { whiteSpace: 'nowrap' } }}>
        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0, paddingLeft: '10px', paddingRight: 0 } }}>
          <TableCell scope="row">{loyaltyProgram?.name ?? '-'}</TableCell>
          <TableCell scope="row">{loyaltyProgram?.referenceNo ?? '-'}</TableCell>
          <TableCell scope="row">{loyaltyProgram?.remark ?? '-'}</TableCell>
        </TableRow>
      </Tabular>
    </Box>
  );
};

export default LoyaltyProgramSection;
